import { Injectable } from '@angular/core';
import { BehaviorSubject, forkJoin, of, Observable } from 'rxjs';
import {
  NavbarCartModel,
  NavbarCartService,
  CartService,
  ProductService,
  PriceService,
  SelectedCustomerService,
  NavbarCartItem,
  CartTotalsService,
  ProductInputQuantityConfigService
} from 'gung-standard';
import { switchMap, map, first } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ColmecNavbarCartService extends NavbarCartService {
  constructor(
    protected cartService: CartService,
    protected productService: ProductService,
    protected priceService: PriceService,
    protected customerService: SelectedCustomerService,
    protected cartTotalsService: CartTotalsService,
    protected productInputQuantityConfigService: ProductInputQuantityConfigService
  ) {
    super(cartService, productService, priceService, customerService, cartTotalsService, productInputQuantityConfigService);
  }

  protected getContent$() {
    return this.cartService.getCurrentCart().pipe(
      switchMap(rows => {
        return forkJoin({
          rows: of(rows)
        });
      }),
      switchMap(({ rows }) => {
        const allRows = [...rows];
        const idQtyMap = allRows.reduce((acc, curr) => ({ ...acc, [curr.productId]: curr.qty }), {});
        const ids = allRows.map(row => row.productId);
        return forkJoin({
          rows: of(allRows),
          products:
            ids.length === 0 ? of([]) : forkJoin(ids.map(id => this.productService.getProduct(id).pipe(first()))),
          prices: this.priceService.getCartRowPricesObservable(allRows).pipe(first())
        });
      }),
      map(({ rows, products, prices }) => {
        const toReturnRows = rows.map(row => {
          const rowProduct = products.find(p => p.id === row.productId);
          const rowPrice = prices.find(r => r.productId === row.productId);
          if (!rowProduct || !rowPrice) {
            throw new Error('Could not find mapped product or price');
          }
          const data: NavbarCartItem = {
            product: rowProduct,
            price: rowPrice,
            cartRow: row
          };
          return data;
        });
        const totalValue = toReturnRows
          .map(row => row.price.cartRowUnitPriceInclRowDiscount.value * row.cartRow.qty)
          .reduce((acc, curr) => acc + curr, 0);
        const currency = prices.length > 0 ? prices[0].customerNetPrice.currencyCode : '';
        const rowsMapped = {};
        toReturnRows.forEach(row => {
          rowsMapped[row.cartRow.productId + (row.cartRow.productPartialId ? '_' + row.cartRow.productPartialId : '')] =
            row;
        });
        return {
          rows: toReturnRows,
          totalValue,
          rowsMapped,
          currency,
          totalQuantity: null // Added to match super. Did not exist in Colmec implementation and is thus (probably) not used.
        };
      })
    );
  }
}
